export default {
  nav: {
    home: '首页',
    about: '关于我们',
    products: '产品中心',
    news: '新闻资讯',
    contact: '联系我们'
  },
  brand: {
    name: '临沂威尼佳贸易有限公司'
  },
  lang: {
    zh: '中文',
    en: 'English'
  },
  contact: {
    phone: '+86 15163903660',
    email: 'postmaster5@lyyllb.com'
  },
  home: {
    heroTitle: '临沂威尼佳贸易有限公司',
    heroSubtitle: '专业 · 专注 · 用心服务客户',
    introTitle: '专业，专注，用心服务客户',
    introDesc: '临沂威尼佳贸易有限公司位于中国山东省临沂市，交通便利，地理位置优越，物流便利。作为一家富有创造力和快速成长的公司，一直致力于为客户提供最卓越的价值服务。',
    introDetail: '本公司是一家生产销售为一体的企业，现有生产设备20余套，厂区占地15亩，仓储存量2000平米，专业生产自动变光焊帽、手持式焊接面罩、塑料防护面罩、多类型护目镜等劳保用品。',
    introFeatures: {
      equipment: '20+套生产设备',
      area: '15亩厂区面积',
      warehouse: '2000m²仓储'
    },
    stats: {
      founded: '公司成立于',
      employees: '现有员工',
      area: '占地面积',
      exports: '年出口量'
    },
    advantages: {
      direct: {
        title: '工厂直销',
        desc: '位于山东省临沂市，靠近青岛港。工厂批发价，可提供最大折扣。大多数产品的订单数量不受限制。',
        features: {
          '1': '批发价格',
          '2': '灵活起订',
          '3': '物流便捷'
        }
      },
      custom: {
        title: '个性定制',
        desc: '您的logo、包装印刷、彩色贴花设计都可以定制。我们尽力满足您的要求。目前，对于自动变光电焊头盔，我们有20多种不同颜色的贴花型号供您选择。',
        features: {
          '1': 'LOGO定制',
          '2': '包装定制',
          '3': '20+贴花'
        }
      },
      quality: {
        title: '品质保证',
        desc: '我们有自己的专业质量控制团队。每一个产品出厂前都会进行专业细致的品质检验。',
        features: {
          '1': 'QC团队',
          '2': '出厂检验',
          '3': '质量认证'
        }
      },
      delivery: {
        title: '准时交付',
        desc: '我们接受灵活的配送方式，可以拼箱，也可以直接配送到您指定的仓库。并能保证及时交货。',
        features: {
          '1': '灵活配送',
          '2': '拼箱服务',
          '3': '准时发货'
        }
      }
    },
    news: {
      title: '最新资讯',
      subtitle: '了解我们的最新动态和行业资讯',
      readMore: '阅读更多',
      viewAll: '查看全部',
      items: {
        1: {
          title: '别让"裸焊"成为伤害父亲的武器！',
          excerpt: '电焊的过程中会产生强烈的电弧光和大量的有害气体以及不同程度的金属溶液飞溅...',
          month: '9月'
        },
        2: {
          title: '面部防护之不同焊接面罩的优缺点',
          excerpt: '焊接面罩是人们进行电工焊接、金属切割以及焊割等作业时，用于保护人体面部的劳保防护用品...',
          month: '9月'
        },
        3: {
          title: '电焊面罩哪种好',
          excerpt: '伤害眼睛的是电焊弧光、紫外线和红外线，所以专业的焊工，最好还是用自动变光电焊面罩...',
          month: '9月'
        }
      }
    },
    products: {
      title: '精选产品',
      subtitle: '高品质焊接安全防护装备',
      viewMore: '查看全部产品',
      hot: '热销',
      popular: '热门'
    },
    factory: {
      title: '工厂展示',
      subtitle: '见证专业与品质的力量'
    },
    cta: {
      title: '需要了解更多产品信息？',
      text: '我们的专业团队随时为您服务，提供最优质的产品和最专业的咨询',
      contact: '立即咨询'
    },
    scrollDown: '向下滚动',
    introBadge: '用心服务',
    readMore: '了解更多',
    contact: {
      title: '联系我们',
      subtitle: '随时与我们取得联系',
      phone: '电话',
      email: '邮箱',
      address: '地址'
    }
  },
  about: {
    introTag: '公司简介',
    introTitle: '临沂威尼佳贸易有限公司',
    introSubtitle: '专业，专注，用心服务客户',
    introDesc: '临沂威尼佳贸易有限公司位于中国山东省临沂市，交通便利，地理位置优越，物流便利。作为一家富有创造力和快速成长的公司，一直致力于为客户提供最卓越的价值服务。',
    introDesc2: '本公司是一家生产销售为一体的企业，现有生产设备20余套，厂区占地15亩，仓储存量2000平米，专业生产自动变光焊帽、手持式焊接面罩、塑料防护面罩、多类型护目镜等劳保用品。',
    experience: '年行业经验',
    advantages: {
      title: '为什么选择我们',
      subtitle: '专业品质，值得信赖',
      direct: {
        title: '工厂直销',
        desc: '位于山东省临沂市，靠近青岛港。工厂批发价，可提供最大折扣。大多数产品的订单数量不受限制。',
        features: {
          '1': '批发价格',
          '2': '灵活起订',
          '3': '物流便捷'
        }
      },
      custom: {
        title: '个性定制',
        desc: '您的logo、包装印刷、彩色贴花设计都可以定制。我们尽力满足您的要求。目前，对于自动变光电焊头盔，我们有20多种不同颜色的贴花型号供您选择。',
        features: {
          '1': 'LOGO定制',
          '2': '包装定制',
          '3': '20+贴花'
        }
      },
      quality: {
        title: '品质保证',
        desc: '我们有自己的专业质量控制团队。每一个产品出厂前都会进行专业细致的品质检验。',
        features: {
          '1': 'QC团队',
          '2': '出厂检验',
          '3': '质量认证'
        }
      },
      delivery: {
        title: '准时交付',
        desc: '我们接受灵活的配送方式，可以拼箱，也可以直接配送到您指定的仓库。并能保证及时交货。',
        features: {
          '1': '灵活配送',
          '2': '拼箱服务',
          '3': '准时发货'
        }
      }
    },
    timeline: {
      title: '公司发展历程',
      subtitle: '从一个小作坊到专业企业',
      founded: '公司成立',
      foundedDesc: '临沂威尼佳贸易有限公司正式成立，开启创业之路',
      expansion: '规模扩展',
      expansionDesc: '引进先进生产设备，扩大生产规模',
      innovation: '产品创新',
      innovationDesc: '推出自主研发的自动变光电焊头盔产品线',
      market: '市场拓展',
      marketDesc: '开始拓展海外市场，产品远销多个国家',
      modernization: '现代化升级',
      modernizationDesc: '完成工厂现代化改造，引进智能化生产线',
      development: '持续发展',
      developmentDesc: '持续创新，为客户提供更优质的产品和服务'
    },
    stats: {
      title: '公司实力',
      subtitle: '多年经验积累',
      founded: '公司源于',
      employees: '员工数量',
      area: '占地面积',
      exports: '年出口量'
    },
    features: {
      factory: {
        title: '自建工厂',
        desc: '15亩现代化厂房'
      },
      equipment: {
        title: '先进设备',
        desc: '20余套生产设备'
      },
      storage: {
        title: '充足库存',
        desc: '2000平米仓储'
      }
    },
    factory: {
      title: '工厂展示',
      subtitle: '先进的生产设备，专业的生产团队',
      viewLarge: '查看大图'
    },
    cta: {
      title: '期待与您合作',
      text: '无论您是寻求产品还是合作机会，我们都热忱欢迎您的咨询'
    }
  },
  products: {
    categories: {
      weldingGlasses: '焊接眼镜',
      safetyGlasses: '防护眼镜',
      weldingMask: '焊接面罩',
      protectiveGear: '其他防护'
    },
    categoryDesc: {
      weldingGlasses: '专业焊接防护眼镜，多种规格可选，保护焊工眼睛免受紫外线和红外线伤害',
      safetyGlasses: '通用型防护眼镜，适用于多种工作场景，有效防护眼睛安全',
      weldingMask: '焊接面罩系列，提供全面的面部防护，包括手持式和头盔式',
      protectiveGear: '其他防护用品，包括手套、口罩、头盔等，全方位保护工作者安全'
    },
    pageTitle: '产品中心',
    pageSubtitle: '满足您所有需求的高品质劳保用品',
    listTitle: '产品列表',
    hot: '热门',
    viewDetail: '查看详情',
    contactUs: '联系我们',
    emptyTitle: '暂无产品',
    emptyDesc: '该分类下暂无产品，请选择其他分类',
    features: {
      title: '为什么选择我们',
      subtitle: '我们的优势',
      items: {
        quality: {
          title: '质量认证',
          desc: '产品均通过ISO质量认证'
        },
        shipping: {
          title: '快速发货',
          desc: '库存充足，下单即发货'
        },
        support: {
          title: '技术支持',
          desc: '专业技术团队提供支持'
        },
        service: {
          title: '售后服务',
          desc: '完善的售后服务体系'
        }
      }
    },
    cta: {
      title: '需要定制产品？',
      desc: '我们提供OEM/ODM服务，支持logo、包装、颜色贴花等定制'
    },
    modal: {
      specs: '产品特点：',
      contactUs: '获取报价'
    },
    items: {
      1: {
        name: '焊接眼镜',
        desc: '专业焊接防护，防紫外线红外线，保护焊工眼睛安全',
        specs: {
          0: '防UV400',
          1: '防飞溅',
          2: '轻便舒适',
          3: '视野清晰'
        }
      },
      2: {
        name: '焊接眼镜',
        desc: '深色镜片设计，专业焊接使用，有效阻挡强光',
        specs: {
          0: '深色镜片',
          1: '防强光',
          2: '耐磨涂层',
          3: '可调节'
        }
      },
      3: {
        name: '焊接眼镜',
        desc: '舒适轻便设计，长时间佩戴无压力',
        specs: {
          0: '轻量设计',
          1: '人体工学',
          2: '透气性好',
          3: '耐用材质'
        }
      },
      4: {
        name: '焊接眼镜',
        desc: '专业级防护，适合高频焊接作业',
        specs: {
          0: '专业级镜片',
          1: '高频焊接',
          2: '全面防护',
          3: '高透光率'
        }
      }
    }
  },
  news: {
    pageTitle: '新闻资讯',
    pageSubtitle: '最新动态和行业资讯',
    search: '搜索新闻...',
    categories: {
      all: '全部',
      safety: '安全知识',
      product: '产品资讯',
      industry: '行业资讯',
      other: '其他'
    },
    tags: {
      safety: '焊接安全',
      glasses: '防护眼镜',
      helmet: '电焊头盔',
      labor: '劳保用品',
      industry: '行业动态',
      quality: '产品质量',
      knowledge: '安全知识'
    },
    readMore: '阅读全文',
    viewDetail: '查看详情',
    emptyTitle: '暂无相关新闻',
    emptyDesc: '请尝试其他搜索关键词或分类',
    pagination: {
      total: '共',
      articles: '篇文章'
    },
    sidebar: {
      contact: '联系我们',
      phone: '电话',
      email: '邮箱',
      address: '地址',
      addressValue: '山东省临沂市',
      contactForm: '在线留言',
      popular: '热门文章',
      categories: '文章分类'
    },
    modal: {
      share: '分享到：',
      views: '阅读'
    },
    articles: {
      1: {
        title: '别让"裸焊"成为伤害父亲的武器！',
        excerpt: '电焊的过程中会产生强烈的电弧光和大量的有害气体以及不同程度的金属溶液飞溅。电弧光中包含强烈的紫外线（UV）红外线（IR）和可见光，这也是电弧光伤害眼睛的原因。',
        content: '电焊作业是一项危险性较高的工作，如果不做好防护措施，会对工人的身体健康造成严重威胁。其中，眼睛是最容易受到伤害的部位。电焊过程中产生的紫外线会灼伤角膜，红外线会导致白内障，而可见光的强光则会暂时性地影响视力...'
      },
      2: {
        title: '面部防护之不同焊接面罩的优缺点',
        excerpt: '选择合适的焊接面罩对保护焊工安全至关重要。本文对比了几种常见类型的焊接面罩，帮助您做出明智的选择。',
        content: '选择焊接面罩时需要考虑防护等级、舒适度和易用性等因素。本文将对比不同类型的焊接面罩，包括手持式面罩、固定式面罩和自动变光面罩...'
      },
      3: {
        title: '电焊面罩哪种好',
        excerpt: '市场上焊接面罩种类繁多，如何选择适合自己的？本文提供全面指南，帮助您选择最佳焊接面罩。',
        content: '焊接面罩的选择取决于焊接类型、工作环境和个人偏好等因素。自动变光电焊头盔由于其便利性和安全性正变得越来越受欢迎...'
      },
      4: {
        title: '焊接作业中眼部防护的重要性',
        excerpt: '眼部防护是焊接安全最重要的方面之一。本文解释了为什么焊工佩戴适当的眼部防护装备至关重要。',
        content: '焊接产生的强光和有害辐射会造成永久性眼部损伤。适当的焊接护目镜或带有合适遮光等级的头盔对于保护眼睛至关重要...'
      },
      5: {
        title: '焊接防护装备新安全标准出台',
        excerpt: '焊接防护装备新安全标准已发布，提高了对产品质量和防护等级的要求。',
        content: '新标准要求焊接防护装备满足更高的安全性能要求，包括更好的UV/IR防护、抗冲击性和阻燃性...'
      },
      6: {
        title: '如何正确维护您的焊接头盔',
        excerpt: '正确维护焊接头盔可以延长其使用寿命并确保最佳防护效果。本文提供维护焊接设备的技巧。',
        content: '定期清洁、检查和更换磨损部件对于维持焊接头盔的性能至关重要。不使用时正确存放也可以防止损坏...'
      },
      7: {
        title: '夏季焊接安全注意事项',
        excerpt: '炎热天气下焊接面临额外挑战。本文提供夏季焊接的安全提示。',
        content: '高温会影响焊工的舒适度和设备性能。适当补水、通风和耐热服装至关重要...'
      },
      8: {
        title: '新款防护眼镜上市',
        excerpt: '临沂威尼佳贸易有限公司推出全新一代防护眼镜，采用新型防雾材料，视野更清晰，佩戴更舒适。',
        content: '我们很高兴地宣布，临沂威尼佳贸易有限公司最新研发的防护眼镜正式上市。这款产品采用了革命性的防雾涂层技术，即使在潮湿环境下也能保持镜片清晰...'
      }
    }
  },
  contact: {
    pageTitle: '联系我们',
    pageSubtitle: '获取报价和咨询服务',
    info: {
      address: {
        title: '公司地址',
        value: '山东省临沂市',
        label: '欢迎来访参观'
      },
      phone: {
        title: '联系电话',
        label: '24小时服务热线'
      },
      email: {
        title: '电子邮箱',
        label: '工作时间回复'
      },
      whatsapp: {
        title: 'WhatsApp',
        label: '快速咨询'
      }
    },
    form: {
      title: '发送询价',
      subtitle: '填写以下表单，我们将在24小时内与您联系',
      name: '姓名',
      namePlaceholder: '请输入您的姓名',
      phone: '联系电话',
      phonePlaceholder: '请输入您的联系电话',
      email: '电子邮箱',
      emailPlaceholder: '请输入您的电子邮箱',
      company: '公司名称',
      companyPlaceholder: '请输入您的公司名称',
      subject: '留言主题',
      subjectPlaceholder: '请选择留言主题',
      subjectOptions: {
        product: '产品咨询',
        quote: '询价报价',
        cooperation: '合作洽谈',
        feedback: '意见反馈',
        other: '其他'
      },
      message: '留言内容',
      messagePlaceholder: '请输入您的留言内容，例如您感兴趣的产品、期望的价格区间、联系方式等',
      submit: '提交留言',
      submitting: '提交中...',
      reset: '重置表单',
      success: '提交成功！',
      successMsg: '感谢您的留言，我们将在24小时内与您联系。'
    },
    map: {
      title: '来访地址',
      companyName: '临沂威尼佳贸易有限公司',
      address: '山东省临沂市'
    }
  },
  footer: {
    logo: '临沂威尼佳贸易',
    desc: '我们专注于提供一站式服务，涵盖各类劳动防护用品，满足您的多样化需求，包括：安全眼镜、塑料面罩、焊接面罩、焊接头盔（尤其是不同款式的自动调光焊接头盔）、安全帽及其他相关焊接工具。',
    links: {
      title: '快速链接',
      items: {
        home: '首页',
        about: '关于我们',
        products: '产品中心',
        news: '新闻资讯',
        contact: '联系我们'
      }
    },
    products: {
      title: '产品分类',
      items: {
        helmet: '自动变光电焊头盔',
        glasses: '焊接防护眼镜',
        shield: '塑料防护面罩',
        mask: '手持焊接面罩',
        goggles: '安全护目镜'
      }
    },
    contact: {
      title: '联系我们',
      address: '地址',
      addressValue: '山东省临沂市',
      phone: '电话',
      email: '邮箱'
    },
    newsletter: {
      title: '订阅资讯',
      desc: '订阅我们的最新动态和优惠信息',
      placeholder: '请输入您的邮箱地址',
      subscribe: '订阅',
      success: '感谢您的订阅！我们将定期向您发送最新资讯。'
    },
    copyright: {
      company: '临沂威尼佳贸易有限公司',
      reserved: '版权所有'
    },
    badges: {
      quality: '品质保证',
      delivery: '准时发货',
      support: '24/7 支持'
    }
  }
}
